import IntegrationsList from './IntegrationsList';

export default IntegrationsList;
